// extracted by mini-css-extract-plugin
export var orderDetails = "_s8-2";
export var orderImage = "_s8-1";
export var orderMeta = "_s8-3";
export var orderSummary = "_s8-0";
export var rightArrow = "_s8-4";